import CnsValidate from './rules/cns';

export default function (value, args) {
  return CnsValidate(value)
}